module.exports = __webpack_public_path__ + "img/innova-startup-week-2023.fb9cd504.png";